/* Home — Try the controls: play/pause, track skip, hold for volume, double-tap − for the sleep timer. */
(function () {
  var TYPE = 'home-controls';

  function init(root) {
    if (!root || root._hc) return;
    root._hc = true;
    var D = window.Dozzee || {};
    var S = {};
    try { S = JSON.parse(root.querySelector('[data-hc-strings]').textContent); } catch (e) { return; }
    var $ = function (s) { return root.querySelector(s); };
    var el = {
      bg: $('[data-track-bg]'), status: $('[data-status]'), name: $('[data-track-name]'), kind: $('[data-track-kind]'),
      vol: Array.prototype.slice.call(root.querySelectorAll('[data-vol] span')), timer: $('[data-timer]'),
      toast: $('[data-toast]'), band: $('[data-band]'), play: $('[data-play]'), pause: $('[data-pause]'),
      playBtn: $('[data-btn="play"]'), eq: Array.prototype.slice.call(root.querySelectorAll('[data-eq]'))
    };
    var st = { playing: false, track: 0, vol: 4, timer: 0 };

    /* Real sleep sounds, generated in the browser (ported from the Dozzee app's noise.js):
       brown / pink / white noise, with a slow swell for Ocean Waves. Starts only on a tap. */
    var snd = (function () {
      if (!S.sound) return null;
      var AC = window.AudioContext || window.webkitAudioContext;
      if (!AC) return null;
      var ctx, master, src, lfo, lfoGain, cur = -1, bufs = {};
      function buffer(type) {
        if (bufs[type]) return bufs[type];
        var len = ctx.sampleRate * 4, b = ctx.createBuffer(1, len, ctx.sampleRate), d = b.getChannelData(0);
        var last = 0, b0 = 0, b1 = 0, b2 = 0;
        for (var i = 0; i < len; i++) {
          var w = Math.random() * 2 - 1;
          if (type === 'white') d[i] = w * 0.3;
          else if (type === 'pink') {
            b0 = 0.99765 * b0 + w * 0.099046; b1 = 0.963 * b1 + w * 0.2965164; b2 = 0.57 * b2 + w * 1.0526913;
            d[i] = (b0 + b1 + b2 + w * 0.1848) * 0.07;
          } else { last = (last + 0.02 * w) / 1.02; d[i] = last * 3.5; }
        }
        return (bufs[type] = b);
      }
      function level() { return Math.pow(st.vol / 10, 1.6) * 0.5; }
      function stopSrc(fade) {
        if (!src) return;
        var s = src, l = lfo, t = ctx.currentTime;
        master.gain.cancelScheduledValues(t);
        master.gain.setTargetAtTime(0, t, fade ? 0.12 : 0.02);
        setTimeout(function () { try { s.stop(); if (l) l.stop(); } catch (e) {} }, fade ? 500 : 80);
        src = lfo = lfoGain = null; cur = -1;
      }
      function start(i) {
        var t = S.tracks[i];
        if (!ctx) { ctx = new AC(); master = ctx.createGain(); master.gain.value = 0; master.connect(ctx.destination); }
        if (ctx.state === 'suspended') ctx.resume();
        stopSrc(false);
        var g = ctx.createGain();
        src = ctx.createBufferSource(); src.buffer = buffer(t.noise || 'brown'); src.loop = true;
        if (t.wave) {
          lfo = ctx.createOscillator(); lfo.frequency.value = 0.1;
          lfoGain = ctx.createGain(); lfoGain.gain.value = 0.45; g.gain.value = 0.55;
          lfo.connect(lfoGain).connect(g.gain); lfo.start();
        }
        src.connect(g).connect(master); src.start();
        cur = i;
        master.gain.cancelScheduledValues(ctx.currentTime);
        master.gain.setTargetAtTime(level(), ctx.currentTime + 0.05, 0.25);
      }
      return {
        sync: function () {
          if (!st.playing) { stopSrc(true); return; }
          if (cur !== st.track) start(st.track);
          else master.gain.setTargetAtTime(level(), ctx.currentTime, 0.08);
        },
        stop: function () { stopSrc(true); }
      };
    })();
    var gsap = null, eqT = [];
    var holdT, holdI, minusT, held = false, pressed = null, lastMinus = 0;

    function g() { return gsap || window.gsap || null; }

    /* band colour follows the shared colour store */
    function paintBand(c) { if (c && el.band) el.band.style.backgroundColor = c.hex; }
    if (D.getColour) paintBand(D.getColour());
    var onColour = function (e) { paintBand(e.detail && e.detail.colour); };
    document.addEventListener('dozzee:colour', onColour);
    root._hcOff = function () {
      document.removeEventListener('dozzee:colour', onColour); clearSim(); clearTimeout(minusT);
      if (snd) snd.stop();
      if (io) io.disconnect();
      document.removeEventListener('visibilitychange', onHide);
    };
    /* pause the sound when the demo scrolls away or the tab is hidden */
    function quietPause() { if (st.playing) { var prev = { playing: true }; st.playing = false; render(prev); if (snd) snd.sync(); } }
    var io = null;
    if (snd && 'IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (!e.isIntersecting) quietPause(); }); }, { threshold: 0 });
      io.observe(root);
    }
    var onHide = function () { if (document.hidden) quietPause(); };
    document.addEventListener('visibilitychange', onHide);

    function render(prev) {
      var t = S.tracks[st.track];
      el.bg.style.background = t.bg;
      el.name.textContent = t.name;
      el.kind.textContent = t.kind;
      el.status.textContent = st.playing ? S.nowPlaying : S.paused;
      el.play.hidden = st.playing; el.pause.hidden = !st.playing;
      el.playBtn.setAttribute('aria-pressed', st.playing ? 'true' : 'false');
      el.vol.forEach(function (s, i) { s.classList.toggle('is-on', i < st.vol); });
      el.timer.textContent = st.timer ? st.timer + (st.timer === 1 ? S.hour : S.hours) : S.off;
      el.timer.classList.toggle('is-on', !!st.timer);
      if (prev.playing !== st.playing) {
        var G = g();
        if (st.playing) eqT.forEach(function (tw) { tw.play(); });
        else { eqT.forEach(function (tw) { tw.pause(); }); if (G) G.to(el.eq, { scaleY: 0.2, duration: 0.3 }); }
      }
    }
    function say(msg, patch) {
      var prev = { playing: st.playing };
      for (var k in patch) st[k] = patch[k];
      render(prev);
      if (snd) snd.sync();
      el.toast.textContent = msg;
      var G = g();
      if (G) G.fromTo(el.toast, { y: 8, opacity: 0 }, { y: 0, opacity: 1, duration: 0.35, ease: 'power2.out' });
    }
    function pulse(btn) {
      var r = root.querySelector('[data-btn="' + btn + '"] [data-ring]'), G = g();
      if (r && G) G.fromTo(r, { scale: 0.7, opacity: 0.9 }, { scale: 1.7, opacity: 0, duration: 0.6, ease: 'power2.out' });
    }
    function vol(dv) { var v = Math.max(0, Math.min(10, st.vol + dv)); say(dv > 0 ? S.volUp : S.volDown, { vol: v }); }
    function togglePlay() { var p = !st.playing; say(p ? S.playing : S.paused, { playing: p }); }
    function step(dir) { var n = S.tracks.length; say(dir > 0 ? S.next : S.prev, { track: (st.track + dir + n) % n }); }
    function clearSim() { clearTimeout(holdT); clearInterval(holdI); }

    function down(btn, e) {
      if (e && e.button !== undefined && e.button !== 0) return;
      clearSim(); held = false; pressed = btn; pulse(btn);
      if (btn === 'play') return;
      var dv = btn === 'plus' ? 1 : -1;
      holdT = setTimeout(function () { held = true; vol(dv); holdI = setInterval(function () { vol(dv); }, 170); }, 380);
    }
    function up(btn) {
      if (pressed !== btn) return;
      pressed = null; clearSim();
      if (btn === 'play') { togglePlay(); return; }
      if (held) { held = false; return; }
      if (btn === 'plus') { step(1); return; }
      var now = Date.now();
      if (lastMinus && now - lastMinus < 330) {
        clearTimeout(minusT); lastMinus = 0;
        var tm = (st.timer + 1) % 3;
        say(tm === 0 ? S.timerOff : S.timerPrefix + tm + (tm === 1 ? S.hour : S.hours), { timer: tm });
        return;
      }
      lastMinus = now;
      minusT = setTimeout(function () { lastMinus = 0; step(-1); }, 330);
    }
    function cancel() { if (!pressed) return; pressed = null; held = false; clearSim(); }

    Array.prototype.forEach.call(root.querySelectorAll('[data-btn]'), function (b) {
      var k = b.getAttribute('data-btn');
      b.addEventListener('pointerdown', function (e) { down(k, e); });
      b.addEventListener('pointerup', function () { up(k); });
      b.addEventListener('pointerleave', cancel);
      b.addEventListener('pointercancel', cancel);
      b.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      /* keyboard activation (detail 0): Enter / Space */
      b.addEventListener('click', function (e) {
        if (e.detail !== 0) return;
        if (k === 'play') togglePlay(); else step(k === 'plus' ? 1 : -1);
      });
    });

    if (D.gsap) D.gsap(function (G) {
      gsap = G;
      if (D.reduce) return;
      eqT = el.eq.map(function (b, k) {
        return G.to(b, { scaleY: 'random(0.3,1)', duration: 'random(0.22,0.42)', ease: 'sine.inOut', repeat: -1, yoyo: true, repeatRefresh: true, paused: true, delay: k * 0.05 });
      });
      if (st.playing) eqT.forEach(function (tw) { tw.play(); });
      root._hcKill = function () { eqT.forEach(function (tw) { tw.kill(); }); };
    });
  }

  function all(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-section-type="' + TYPE + '"]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    Array.prototype.forEach.call(e.target.querySelectorAll('[data-section-type="' + TYPE + '"]'), function (r) {
      if (r._hcOff) r._hcOff();
      if (r._hcKill) r._hcKill();
    });
  });
})();
